import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Form, Field } from 'formik'
import classNames from 'classnames'

import Button from 'components/Atoms/Button'
import TextDivisor from 'components/Atoms/TextDivisor'
import isLightMode from 'helpers/isLightMode'
import { TextField, PhoneField } from 'components/Molecules/Form'

const Component = styled(Form)`
  margin-top: 20px;
  text-align: center;
`

const TransferYourPassForm = ({
  application,
  isSubmitting,
  isValid,
  setFieldValue,
  setStatus,
  setTouched,
  t,
}) => (
  <Component>
    <Field
      name="phoneNumber"
      label={t('transferYourPass.form.phoneNumber.label')}
      disabled={isSubmitting}
      component={PhoneField}
      onFocus={() => {
        setTouched({ phoneNumber: false })
        setFieldValue('email', '')
        setStatus(null)
      }}
    />
    <TextDivisor
      className="phoneNumber"
      text={t('transferYourPass.form.divisor')}
    />
    <Field
      name="email"
      disabled={isSubmitting}
      label={t('transferYourPass.form.email.label')}
      component={TextField}
      onFocus={() => {
        setTouched({ email: false })
        setFieldValue('phoneNumber', '')
        setStatus(null)
      }}
    />
    <Button
      className={classNames('extraPadding', 'full', {
        highlight: isLightMode(application),
        contrastText: !isLightMode(application),
      })}
      disabled={isSubmitting || !isValid}
      type="submit">
      {t('transferYourPass.form.button').toUpperCase()}
    </Button>
  </Component>
)

TransferYourPassForm.propTypes = {
  application: PropTypes.string,
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  setFieldValue: PropTypes.func,
  setStatus: PropTypes.func,
  setTouched: PropTypes.func,
  t: PropTypes.func,
}

export default TransferYourPassForm
